// src/pages/churches/churchForm.js
import React, { useState } from "react";
import { REGION_OPTIONS } from "./churchConstants";
import { CHURCH_FEATURES } from "./churchFeatures";
import { createChurch, updateChurch } from "./churchService";

export default function ChurchForm({ church, onClose, onSaved }) {
  const isKnownRegion = church?.region && REGION_OPTIONS.some((r) => r.value === church.region);

  const [form, setForm] = useState({
    name: church?.name || "",
    address: church?.address || "",
    region: isKnownRegion ? church.region : church?.region ? "__CUSTOM__" : "",
    customRegion: !isKnownRegion ? church?.region || "" : "",
    email: church?.email || "",
    phone: church?.phone || "",
    features: church?.features || {}
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      region: form.region === "__CUSTOM__" ? form.customRegion.trim() : form.region
    };

    delete payload.customRegion;

    if (!payload.region) {
      alert("Please provide a valid region");
      return;
    }

    if (church) {
      await updateChurch(church.churchId, payload);
    } else {
      await createChurch(payload);
    }

    onSaved();
    onClose();
  };

  return (
    <div className="church-form">
      <h3>{church ? "Edit Church" : "Add Church"}</h3>

      <form onSubmit={handleSubmit}>
        <input name="name" placeholder="Church Name" value={form.name} onChange={handleChange} required />
        <textarea name="address" placeholder="Address" value={form.address} onChange={handleChange} required />

        <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} />
        <input name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} />

        <h4>Features</h4>

        <div className="feature-toggle-list">
          {Object.values(CHURCH_FEATURES).map((feature) => (
            <label key={feature.key} className="feature-toggle">
              <input
                type="checkbox"
                checked={form.features?.[feature.key] || false}
                onChange={(e) =>
                  setForm({
                    ...form,
                    features: {
                      ...form.features,
                      [feature.key]: e.target.checked
                    }
                  })
                }
              />
              <span>{feature.label}</span>
            </label>
          ))}
        </div>
        <div className="form-actions">
          <button type="submit">Save</button>
          <button type="button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
